<template>
	<div class="b roleAuthorityConsult">
		<Nav current="我的公司"></Nav>
		<div class="info clearfix">
			<div class="item clearfix">
				<div class="item-l breadCrumb"><a>系统管理</a> > <a>角色管理</a> > <a>{{roleName}}</a> > 权限设置<el-button
						style="margin: 0 8px; vertical-align: 1px;" size="mini" type="primary" class="el-button btnSty"
						@click="back">
						返回
					</el-button>
				</div>

			</div>
		</div>
		<div class="content">
			<div class="rbac clearfix">
				<div class="block">
					<div class="caption">修改权限</div>
					<div class="tablelist" style="background: #f8f8f8; position: relative;">
						<h3>相同权限</h3>
						<el-button style="position: absolute; right: 10px; top: 34px;" size="mini" type="primary" @click="submit(1)"
							class="el-button btnSty">保存</el-button>
						<ul id="treeDemo" class="ztree"></ul>
					</div>
					<div class="tablelist r" style="background: #f8f8f8;">
						<h3>不同权限<span style="font-size: 12px; color: red; margin-left: 10px;">*保存所选系统下权限设置</span></h3>
						<div class="clearfix" style="font-size: 14px; line-height: 30px;">
							<div class="l">当前系统：</div>
							<div class="l">
								<el-select size="mini" v-model="value" placeholder="请选择" @change="changeValue">
									<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
								<el-button style="margin: 0 8px;" size="mini" type="primary" class="el-button btnSty" @click="submit(2)">
									保存</el-button>
							</div>
						</div>
						<ul id="treeDemo1" class="ztree"></ul>
					</div>
				</div>
				<div class="block">
					<div class="caption">参考权限
						<input class="inputText" type="text" v-model="roleAuthorityConsultName" placeholder="查询角色名称"> <span class="el-icon-search" @click="searchRoleAuthorityConsult"></span>
					</div>
					<div class="tablelist" style="background: #f8f8f8; position: relative;">
						<h3>相同权限</h3>
						<ul id="treeDemo3" class="ztree"></ul>
					</div>
					<div class="tablelist r" style="background: #f8f8f8;">
						<h3>不同权限</h3>
						<div class="clearfix" style="font-size: 14px; line-height: 30px;">
							<div class="l">当前系统：</div>
							<div class="l">
								<el-select size="mini" v-model="valueConsult" placeholder="请选择" @change="changeValue(1)">
									<el-option v-for="item in optionsConsult" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>
						<ul id="treeDemo4" class="ztree"></ul>
					</div>
				</div>
				
				<!-- <div class="tips">
					<div class="div">设置角色 [{{roleName}}] 的权限,注意:</div>
					<p>
						1. 勾选checkbox表示本角色具有访问菜单或者操作的权限。
						<br> 2. 当有radio单选按钮时,表示本菜单可以设置用户的数据查看范围。
						<br> 3. <span class="red-txt">修改权限后,角色所对应的用户需要重新登录或者关闭浏览器再打开生效。</span>
						<br> 4. 当勾选的项有灰色背景时，表示该项下的子菜单没有全部勾选。
						<br> 5. 当新建了表单或者报表后，权限需要再次单独勾选。
						<br> 6. 表单历史数据查看范围可以自定义查询规则，支持组织结构和表单数据过滤。
						<br> 7. 表单历史数据查看范围配置组织结构和表单数据过滤规则的时候，请及时保存，系统不会保存页面中间状态。
					</p>
				</div> -->
			</div>
		</div>
		<el-dialog title="自定义过滤器" :visible.sync="dialogFormVisible">
			<el-button style="position: absolute; right: 50px; top: 14px;" size="mini" type="primary" @click="saveCustomize"
				class="el-button btnSty">保存</el-button>
			<el-button style="position: absolute; right: 114px; top: 14px; background: #fff; color: #409EFF;" size="mini"
				type="primary" @click="close()"
				class="el-button btnSty">关闭</el-button>
			<template v-if="dialogFormVisible">
				<ul id="treeDemo2" class="ztree"></ul>
				<!-- <el-tree :load="loadNode" show-checkbox node-key="id" ref="tree" highlight-current
					:props="defaultProps" lazy
					@check-change="handleCheckChange">
				</el-tree> -->
			</template>
			
		</el-dialog>
	</div>
</template>
<script>
	import Nav from "@/components/Nav.vue";
	import axios from 'axios'
	import apiData from "@/config/api";
	import http from "@/config/httpConfig";
	var IDMark_A = "_a";
	var organizationAndFilterRoleMenuNode;
	function ajaxDataFilter(treeId, parentNode, responseData) {
		console.log(treeId, parentNode, responseData)
		var responseData = responseData.data
    if (responseData) {
      return responseData;
    }
	};
	var asyncData = {
		enable: true,
		dataFilter: ajaxDataFilter,
		type: "get",
		autoParam: ["id","type"]
	}

	function getFont(treeId, node) {
		return node.font ? node.font : {};
	}
	function selectOrganizationAndFilter(ids, names){
		if(organizationAndFilterRoleMenuNode){
			organizationAndFilterRoleMenuNode.customData = ids;
		}
	}
	function modifyHistoryTime() {
		var zTree = $.fn.zTree.getZTreeObj("treeDemo1");
		var node = zTree.getNodes();
		var nodes = zTree.transformToArray(node);
		for (var i = 0, l = nodes.length; i < l; i++) {
			if (nodes[i].id.match(RegExp(/-1/)) || nodes[i].id.match(RegExp(/-2/))) {
				zTree.setChkDisabled(nodes[i], true);
			}
		}
	}
	// 自定义radio
	function addDiyDom(treeId, treeNode) {
		var aObj = $("#" + treeNode.tId + IDMark_A);
		if (treeNode.eradio) {
			//选隐藏checkbox
			var chectBtn = $("#" + treeNode.tId + "_check");
			if (chectBtn) chectBtn.remove();
			//再设置radio
			var checked = treeNode.checked ? "checked" : "";
			var chkDisabled = treeNode.chkDisabled
			var purl = treeNode.purl
			if (purl === "form_limits_edit_formdata" && treeId != 'treeDemo4') { //编辑历史数据
				var editStr =
					'<span style="display:none;" + "_check class=" button chk radio_false_disable" onclick=""></span>'
				editStr += "<input type='radio' class='radioBtn' id='" + treeNode.tId + "_radio'	name='radio_" + treeNode
					.getParentNode().id + "' " + checked + "	onfocus='this.blur();'></input>";
			} else {
				if (chkDisabled) { //禁用
					if(treeNode.checked){
						var editStr =
						'<span id="treeNode.tId"+ "_check class="button chk radio_true_disable" treenode_check=""></span>'
					}else {
						var editStr =
						'<span id="treeNode.tId" + "_check class=" button chk radio_false_disable" treenode_check="" onclick=""></span>'
					}
					
				} else {
					var editStr = "<input type='radio' class='radioBtn' id='" + treeNode.tId + "_radio'	name='radio_" + treeNode
						.getParentNode().id + "' " + checked + "	onfocus='this.blur();'></input>";
				}
			}
			aObj.before(editStr);
			var btn = $("#" + treeNode.tId + "_radio");
			if (btn) btn.bind("click", function () {
				if (treeNode.purl === 'form_limits_view_formdata' && treeNode.name === '自定义') {
					organizationAndFilterRoleMenuNode = treeNode;
					var pId = treeNode.pId;
					var form_id = pId.split("_")[1];
					console.log(app)
					app.dialogFormVisible = true
					app.formId = form_id
					app.menuId = pId
					app.getTreeData()
					// app.getCategorylist()
					// app.loadNode()
					// showUrlDialog(
					// 	'/module/organizationAndFilterRoleMenu.action?role_id=8a9e23296ca50893016cb1ec4fcf18b8&menu_id=' + pId
					// 	.split("_")[0] + '&form_id=' + form_id, '自定义过滤器', '420px', '80%', 'dialog_organizationAndFilter');
				}
			});
			if (btn) btn.bind("change", function () {
				checkBrand(treeId, treeNode, btn);
			});
		}
	}
	//节点展开
	function expandNode(event, treeId, treeNode) {
		var id = $(event.currentTarget).attr('id')
		if (id == 'treeDemo1') {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo1");
		} else if(id == 'treeDemo2') {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo2");
		} else if(id == 'treeDemo3') {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo3");
		} else if(id == 'treeDemo4') {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo4");
		}else {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo");
		}
		if (treeNode.name === "编辑历史数据") {
			var btn = $("#" + treeNode.tId + "_check");
			var node = zTree.getNodes();
			var nodes = zTree.transformToArray(node);
			var childNodes = null
			var type = ''
			var parent = null
			// var checkedNodes = zTree.getCheckedNodes()
			for (var i = 0, l = nodes.length; i < l; i++) {
				if (nodes[i].pId === treeNode.pId && nodes[i].name === "查看范围") {
					parent = nodes[i].tId
					childNodes = nodes[i].children
					break
				}
			}
			// console.log(childNodes)
			for (var j = 0, m = childNodes.length; j < m; j++) {
				console.log(childNodes[j])
				console.log(childNodes[j].purl)
				console.log(childNodes[j].purl === "form_limits_view_formdata", childNodes[j].checked, childNodes[j].purl ===
					"form_limits_view_formdata" &&
					childNodes[j].checked)
				if (childNodes[j].purl === "form_limits_view_formdata" && childNodes[j].checked) {
					type = childNodes[j].name
					break
				}
			}
			// historyIsEdit(btn.parent().find('ul'), null, type)
		}
	}
	//radio被选中时的操作
	function checkBrand(treeId, treeNode, btn) {
		var nextLi = null
		var items = []
		if (treeNode.purl === 'form_limits_view_formdata') {
			nextLi = btn.parent().parent().parent().next().find('ul>li')
			console.log(nextLi)
			if (nextLi.length > 0) {
				historyIsEdit(btn.parent().parent().parent().next().find('ul'), nextLi, btn.parent().text())
				for (var index = 0; index < nextLi.length; index++) {
					var liName = nextLi[index].id.trim().split("_")
					items.push(parseInt(liName[1]) - 1)
				}
				// modifyHistoryTime()
			}
		}


		//alert("change:"+treeNode.name+" "+btn.prop("checked"));
		if (btn.prop("checked")) {
			var treeObj = $.fn.zTree.getZTreeObj(treeId);
			var node = treeObj.getNodes();
			var nodes = treeObj.transformToArray(node);
			//设置自己为选中
			treeObj.checkNode(treeNode, true, true, true);
			//同时设置同组其它的隐藏数据为非选中状态
			var others = treeObj.getNodesByParam("pId", treeNode.pId);
			if (others.length > 0) {
				var objNode = null;
				for (var i = 0; i < others.length; i++) {
					objNode = others[i];
					if (treeNode.id != objNode.id && objNode.checked && objNode.eradio) {
						treeObj.checkNode(objNode, false, true, true);
					}
				}
			}
			if (nextLi && nextLi.length > 0) { //清空编辑历史
				var objNode = null;
				for (var i = 0, l = items.length; i < l; i++) {
					console.log(nodes[items[i]])
					if (nodes[items[i]].eradio) {
						console.log(nodes[items[i]])
						treeObj.checkNode(nodes[items[i] - 1], false, true, true);
					}
				}
			}

			//如果是自定义按钮，弹出框
			if ("自定义" === treeNode.name) {
				organizationAndFilterRoleMenuNode = treeNode;
				var pId = treeNode.pId;
				var form_id = pId.split("_")[1];
				app.dialogFormVisible = true
				app.formId = form_id
				app.menuId = pId
				app.getTreeData()
				// app.getCategorylist()
				// app.loadNode()
				// showUrlDialog('/module/organizationAndFilterRoleMenu.action?role_id=8a9e23296ca50893016cb1ec4fcf18b8&menu_id='+pId.split("_")[0]+'&form_id='+form_id,'自定义过滤器','420px','80%','dialog_organizationAndFilter');
			}

		}
	}
	//结点被选中的操作
	function zTreeOnCheck(event, treeId, treeNode) {
		if (treeNode.eradio) return;
		var treeObj = $.fn.zTree.getZTreeObj(treeId);
		//对radio的操作
		if (treeNode.isParent) {
			//先取出本结点下面所有的radio
			var radios = treeObj.getNodesByParam("eradio", true, treeNode);
			var radioPid = null;
			if (radios.length > 0) {
				for (var i = 0; i < radios.length; i++) {
					if (radioPid != radios[i].pId) {
						radioPid = radios[i].pId;
						if (treeNode.checked) {
							//设置一个为选中状态
							var radioNodes = treeObj.getNodesByParam("pId", radioPid);
							var tmp = 0;
							for (var j = 0; j < radioNodes.length; j++) {
								var radioNode = radioNodes[j];
								if (radioNode.eradio) {
									if (tmp == 0) {
										tmp += 1;
										treeObj.checkNode(radioNode, true, true, true);
										$("input:radio[name=radio_" + radioPid + "]").first().prop('checked', true);
									} else {
										treeObj.checkNode(radioNode, false, true, true);
									}
								}
							}

						} else {
							//设置为不选中
							var radio = $("input:radio[name=radio_" + radioPid + "]:checked");
							if (radio) radio.prop('checked', false);
						}
					}
				}
			}
		}
	}
  function F(){
		return {
			view: {
				showLine: true, /*不显示节点之间的连接线*/
			},
			check: {
				enable: true,
				url: '',
				chkboxType:  { "Y": "", "N": "" },
			},
			async: asyncData,
			simpleData: {
				enable: true,
			},
			callback: { 
				onClick: function (e, treeId, treeNode, clickFlag) {
					console.log(e, treeId, treeNode, clickFlag)
					tree2.checkNode(treeNode, !treeNode.checked, true); 
				} 
			},	
		};
	}
	function T() {
		return {
			check: {
				enable: true,
			},
			view: {
				addDiyDom: addDiyDom,
				expandSpeed: "normal",
				fontCss: getFont,
				nameIsHTML: true
			},
			data: {
				simpleData: {
					enable: true
				}
			},
			callback: {
				onCheck: zTreeOnCheck,
				onExpand: expandNode, //节点展开
			}
		}
	}
	let app
	export default {
		components: {
			Nav,
		},
		data() {
			return {
				roleAuthorityConsultName: '',
				categorylist: [],
				defaultProps: {
					children: 'zones',
					label: 'name',
					isLeaf: 'leaf'
				},
				dialogFormVisible: false,
				roleName: '我的角色',
				roleId: '',
				setting: T(),
				setting1: T(),
				setting3: T(),//参考左
				setting4: T(),//参考右
				setting2: F(),
				options: [],
				optionsConsult: [],
				value: '',
				valueConsult: '',//参考当前系统
				zNodes: [],
				zNodes1: []
			};
		},
		created() {},
		mounted() {
			app = this
			console.log(this)
			let roleId = this.$route.query.roleId
			let roleName = this.$route.query.roleName
			this.roleId = roleId
			this.roleName = roleName
			let height = $(window).height() - 170
			$('.content').css({
				"height": height
			})
			$('#treeDemo,#treeDemo11').css({
				"max-height": height
			})
			this.getList()
		},
		methods: {
			close(){
				this.dialogFormVisible = false
			},
			searchRoleAuthorityConsult(){//获取参考权限
				this.getListConsult()
			},
			saveCustomize(){
				var treeObj = $.fn.zTree.getZTreeObj("treeDemo2");
				var nodes = treeObj.getCheckedNodes(true);
				if(nodes.length==0){
					selectOrganizationAndFilter("", "");
				}else{
					var node;
					var ids = "";
					for (var i=0; i<nodes.length; i++) {
						node = nodes[i];
						ids = ids+node.id+"-"+node.type+",";
					}
					selectOrganizationAndFilter(ids, "");
				}
				this.close()
			},
			getTreeData(){
				let _this = this
				let params = {
					businessSystemId: this.value,
					formId: this.formId,
					menuId: this.menuId,
					roleId: this.roleId
				}
				http.get(apiData.roleMenuCustomize, true, params, (res) => {
					let data = res.data.data;
					this.dialogFormVisible = true;
					_this.setting2.async.url = `${apiData.roleMenuCustomizeSon}?formId=${_this.formId}&menuId=${_this.menuId}&roleId=${_this.roleId}&businessSystemId=${_this.value}`
					var tree2 = $.fn.zTree.init($("#treeDemo2"), _this.setting2, data);
				})
			},
			// labelCheckedList接收被勾选的数据
			handleCheckChange(data) {
				this.currTreeId = data.id
				setTimeout(() => {
					let currtData = this.$refs.tree.getCheckedNodes(true)
					this.labelCheckedList = currtData;
				}, 100);
			},
			//懒加载时触发
			loadNode(node, resolve) {
				if (node.level === 0) {
					this.getCategorylist(resolve)
					// return resolve(this.categorylist);
				}
				if (node.data && !node.data.isParent) return resolve([]);
				if (node.level > 0) { // 二级节点
					this.getChildrenNode(node, resolve)
				}
			},
			// 二级节点
			getChildrenNode(node, resolve) {
				let params = {
					businessSystemId: this.value,
					formId: this.formId,
					menuId: this.menuId,
					roleId: this.roleId,
					id: node.data.id,
					type: node.data.type
				}
				http.get(apiData.roleMenuCustomizeSon, true, params, (res) => {
					let data = res.data.data;
					this.childrenList = data;
					if (this.childrenList.length == 0) {
						this.$message.error('数据拉取失败，请刷新再试！');
						return;
					}
					resolve(data);
				})
			},
			// 收起、展示tree
			selectLabelList() {
				if (!this.isShowTree) {
					this.getCategorylist();
				} else {
					this.$refs.tree.$data.store.lazy = false
					this.isShowTree = false;
				}

			},
			//获取一级节点
			getCategorylist(resolve) {
				let params = {
					businessSystemId: this.value,
					formId: this.formId,
					menuId: this.menuId,
					roleId: this.roleId
				}
				http.get(apiData.roleMenuCustomize, true, params, (res) => {
					let data = res.data.data;
					if (data.length > 0) {
						data.forEach(item => {
							item.disabled = true;
						})
					}
					return resolve(data);
					this.categorylist = data;
					this.dialogFormVisible = true;
				})
			},
			back() {
				this.$router.go(-1); //返回上一层
			},
			changeValue(type) {//type:1为参考权限，默认无值
				if(type === 1){
					this.getRightListConsult()
				}else {
					this.getRightList()
				}
				console.log(this.value)
			},
			submit(type) {
				let _this = this
				console.log(type)
				let url = ''
				let businessSystemId = ''
				if (type == 1) { //相同权限
					var treeObj = $.fn.zTree.getZTreeObj("treeDemo");
					url = apiData.roleMenuUpdateFixedMenu
				} else if (type == 2) { //不同权限
					var treeObj = $.fn.zTree.getZTreeObj("treeDemo1");
					url = apiData.roleMenuUpdateBusinessSystemMenu
					businessSystemId = '&businessSystemId=' + this.value
				}
				url = url + '?roleId=' + this.roleId + '&HncToken=' + localStorage.getItem('token') + businessSystemId
				var nodes = treeObj.getCheckedNodes(true);
				var datas = new Array();
				if (nodes.length < 1) {
					alert("您没有选择任何权限");
					$("#submitbtn").removeAttr("disabled");
					return;
				} else {
					var json;
					var node;
					for (var i = 0; i < nodes.length; i++) {
						node = nodes[i];
						json = {
							id: node.id,
							pId: node.pId,
							id: node.id
						}
						if (node.dataType) {
							if (node.dataType == 5) { //过滤查看选项
								continue;
							}
							json.dataType = node.dataType
						}
						if (node.menuOpId) {
							json.menuOpId = node.menuOpId;
						}
						if (node.form_id) {
							json.form_id = node.form_id;
						}
						if (node.type) {
							json.type = node.type;
						}
						if (node.ignore) {
							json.ignore = node.ignore;
						}
						if (node.hasRange) {
							json.hasRange = node.hasRange;
						}
						if (node.customData) {
							json.customData = node.customData;
						}
						datas.push(json);
					}
					console.log(nodes)
					axios({
							headers: {
								'Content-Type': 'application/json'
							},
							method: 'put',
							url: url,
							data: JSON.stringify(datas)
						}).then(res => {
							if (res.status) {
								if (res.data.code == 200) { //正确返回数据
									console.log(res)
									if (type == 1) { //相同权限
										_this.getList(true)
									} else if (type == 2) { //不同权限
										_this.getRightList()
									}
								}
							} else {
								Message({
									showClose: true,
									message: res.data.msg,
									type: 'error',
									duration: 50000
								});
							}
						})
						.catch(err => {
							alert(err);
							// console.log(err)
						})
				}
				// http.post(apiData.roleMenuDynamicNode, true, params, (res) => {
				// 	console.log(res)
				// 	let zNodes = res.data.data
				// 	_this.zNodes1 = zNodes
				// 	console.log(_this.setting)
				// 	$.fn.zTree.init($("#treeDemo1"), _this.setting1, zNodes);
				// })
				// $.ajax({
				// 	type: "post",
				// 	url: "updateJsonRoleMenu.action",
				// 	data: {
				// 		'nodes[]': datas,
				// 		'roleid': '<%=roleid%>'
				// 	},
				// 	dataType: "json",
				// 	success: function (msg) {
				// 		$.unblockUI();
				// 		$("#submitbtn").removeAttr("disabled");
				// 		if (msg && msg.status) {
				// 			window.location.href = "indexRole.action?curmenuid=manage.yhqx_3";
				// 		} else {
				// 			alert(msg.msg);
				// 		}
				// 	}
				// });



			},


			getListConsult(notNeedGetRightList) {
				let _this = this;
				let roleId = this.roleId
				let params = {
					roleName: this.roleAuthorityConsultName
				}
				http.get(apiData.roleMenuListByName, true, params, (res) => {
					let zNodes = res.data.data
					_this.zNodes = zNodes.data
					_this.optionsConsult = zNodes.listBusinessSystem
					console.log(zNodes.listBusinessSystem,'系统')
					_this.valueConsult = zNodes.listBusinessSystem[0].id
					if (!notNeedGetRightList) {
						_this.getRightListConsult()
					}
					for (let index = 0; index < zNodes.data.length; index++) {
						const element = zNodes.data[index];
						element.chkDisabled = true
					}
					$.fn.zTree.init($("#treeDemo3"), _this.setting3, zNodes.data);
				})
			},
			getRightListConsult(){
				let _this = this;
				let roleId = this.roleId
				let params = {
					roleName: this.roleAuthorityConsultName,
					businessSystemId: this.valueConsult
				}
				http.get(apiData.roleMenuDynamicNodeByName, true, params, (res) => {
					console.log(res)
					let zNodes = res.data.data
					_this.zNodes1 = zNodes
					for (let index = 0; index < zNodes.length; index++) {
						const element = zNodes[index];
						element.chkDisabled = true
					}
					$.fn.zTree.init($("#treeDemo4"), _this.setting4, zNodes);
					modifyHistoryTime()
				})
			},
			getRightList() {

				let _this = this;
				let roleId = this.roleId
				let params = {
					roleId,
					businessSystemId: this.value
				}
				http.get(apiData.roleMenuDynamicNode, true, params, (res) => {
					console.log(res)
					let zNodes = res.data.data
					_this.zNodes1 = zNodes
					console.log(_this.setting)
					$.fn.zTree.init($("#treeDemo1"), _this.setting1, zNodes);
					modifyHistoryTime()
				})
			},
			getList(notNeedGetRightList) {
				let _this = this;
				let roleId = this.roleId
				let params = {
					roleId
				}
				http.get(apiData.roleMenuList, true, params, (res) => {
					let zNodes = res.data.data
					_this.zNodes = zNodes.data
					_this.options = zNodes.listBusinessSystem
					console.log(zNodes.listBusinessSystem,'系统')
					_this.value = zNodes.listBusinessSystem[0].id
					// _this.valueConsult = zNodes.listBusinessSystem[0].id
					if (!notNeedGetRightList) {
						_this.getRightList()
					}
					$.fn.zTree.init($("#treeDemo"), _this.setting, zNodes.data);
					console.log(res.data)
				})
			},
			retSuper() {
				this.$router.go(-1);
			},
		},
	};
</script>

<style lang="less">
	.el-dialog__body {
		max-height: 450px;
		overflow: auto;
	}
	.roleAuthorityConsult {
		margin: 0 10px;
		.info {
			margin: 10px 0;
			text-align: left;
		}

		.content {
			text-align: left;

			.rbac {
				height: 100%;
				.caption {
					padding: 0 10px;
					background: #f8f8f8;
					background: #409EFF;
					color: #fff;
					font-weight: bold;
					height: 38px;
					line-height: 38px;
					width: 100%;
					.inputText {
						margin-left: 10px;
						width: 180px;
						height: 26px;
						font-size: 14px;
						padding-left: 10px;
					}
					.el-icon-search {
						margin-top: 0;
						vertical-align: middle;
					}
				}
				.block {
					float: left;
					width: calc(50% - 10px);
					height: 100%;
					&:last-child {
						float: right;
					}
				}

				.tips {
					.red-txt {
						color: red;
					}
					
					.div {
						font-size: 16px;
					}

					font-size: 14px;
					line-height: 1.5;
				}

				.tablelist {
					position: relative;
					float: left;
					height: calc(100% - 38px);
					width: 49%;
					padding: 10px;
					margin-right: 0;
					margin-left: 0;
					border: 1px solid #999;
					border-top: none;
					&.r {
						float: right;
					}

					#treeDemo,#treeDemo3 {
						height: calc(100% - 30px);
						overflow: auto;
					}

					#treeDemo1,#treeDemo4 {
						height: calc(100% - 60px);
						overflow: auto;
					}
				}
			}
		}
		.ztree  {
			li {
				a {
					span {
						&.role_ico_close, &.role_ico_open, &.role_ico_docu {
							margin-right: 30px !important;
							background-position: -110px 0;
							vertical-align: top;
							&::after{
								content: '权限'; /* 插入的文字 */
								top: 8px;
								left: 18px;
								background: rgba(245, 223, 210, 1);
								color: rgba(206, 94, 31, 1);
								margin-left: 18px;
								line-height: 14px;
							}
						}

						&.icon08_ico_docu, &.icon08_role_ico_docu, &.icon08 {
							width: 14px !important;
							height: 15px !important;
							margin-right: 4px !important;
							margin-top: 2px;
							background: url(../../images/report.png) no-repeat center
								center !important;
							background-size: 80%;
							position: relative;
						}
						&.icon09_ico_docu, &.icon09_role_ico_docu, &.icon09 {
							width: 14px !important;
							height: 15px !important;
							margin-right: 4px !important;
							margin-top: 2px;
							background: url(../../images/form.png) no-repeat center
								center !important;
							background-size: 80%;
							position: relative;
						}

						&.icon11_ico_docu, &.icon11_role_ico_docu, &.icon11 {
							width: 14px !important;
							height: 15px !important;
							margin-right: 4px !important;
							margin-top: 2px;
							background: url(../../images/form_index.png) no-repeat center
								center !important;
							background-size: 80%;
						}

						&.icon10_ico_docu, &.icon10_role_ico_docu, &.icon10{
							width: 14px !important;
							height: 15px !important;
							margin-right: 4px !important;
							margin-top: 2px;
							background: url(../../images/form_red.png) no-repeat center
								center !important;
							background-size: 80%;
						}

						&.icon50_ico_docu, &.icon50_role_ico_docu, &.icon50{
							width: 14px !important;
							height: 15px !important;
							margin-right: 4px !important;
							margin-top: 2px;
							background: url(../../images/watch/icon_50.png) no-repeat center
								center !important;
							background-size: 80%;
						}
						&.icon502_ico_docu, &.icon502_role_ico_docu, .icon502{
							width: 14px !important;
							height: 15px !important;
							margin-right: 4px !important;
							margin-top: 2px;
							background: url(../../images/watch/icon_502.png) no-repeat center
								center !important;
							background-size: 100% !important;
						}

						&.icon08_role_ico_docu, &.icon09_role_ico_docu, &.icon10_role_ico_docu, &.icon11_role_ico_docu, &.icon50_role_ico_docu, &.icon502_role_ico_docu{
							margin-right: 30px !important;
						}
						&.icon08_role_ico_docu::after, &.icon09_role_ico_docu::after, &.icon10_role_ico_docu::after, &.icon11_role_ico_docu::after, &.icon50_role_ico_docu::after, &.icon50_role_ico_docu::after{
							content: '权限'; /* 插入的文字 */
							top: 8px;
							left: 18px;
							background: rgba(245, 223, 210, 1);
							color: rgba(206, 94, 31, 1);
							margin-left: 18px;
							line-height: 14px;
						}
					}
				}
			}
		}
		// .ztree li span.button.chk.checkbox_true_disable {
		// 	background-position: -14px -28px;
		// }
		// .ztree li span.button.chk.radio_true_disable {
		// 	background-position: -42px -42px;
		// }
	}
</style>